export const V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE =
  'V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE'

export default data => {
  return {
    type: V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE,
    data,
  }
}
